module.exports = __webpack_public_path__ + "static/media/caret-square-right-regular.6f5ad819.svg";